import React, {Component} from 'react';

import styled from 'styled-components'
import {mixins} from "../../mixins";

import logo from '../../img/logo_white.svg'
import {withRouter} from "react-router";
import {Link} from "react-router-dom";
import {bindActionCreators} from "redux";
import * as Actions from "../../actions/actions";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import Button from "../common/Button";
import Translation from "../dictionary/Translation";


const NavWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

const Logo = styled.div`
`;

const NavActions = styled.div`
  display: flex;
  align-items: center;
  >*{
    margin-right: 20px;
    &:last-child{
      margin-right: 0;
    }
  }
`;

const Placeholder = styled.div`
  height: 60px;
`;

const CartButton = styled(Link)`
  color: ${p => p.theme.cTheme};
  display: block;
  position: relative;
  ${mixins.ease()};
  i{
    font-size: ${p => p.theme.sIcon}px;
    ${mixins.ease()};
  }
  &:hover, &:focus{
    text-decoration: none;
    i{
      color: ${p => p.theme.cWhite}; 
    }
  }
`;

const CartCount = styled.span`
  color: ${p => p.theme.cWhite} !important;
  height: 1em;
  width: 1em;
  position: absolute;
  bottom: -0.1em;
  right: -0.7em;
  border-radius: 50%;
  background-color: ${p => p.theme.cTheme};
  display: flex;
  align-items: center;
  justify-content: center;
`;

class Nav extends Component {

    constructor(props) {
        super(props);

        this.state = {
            folded: this.getFolded(),
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    getFolded = () => {
        return window.pageYOffset > 100;
    };

    handleScroll = (event) => {
        this.setState({
            folded: this.getFolded(),
        });
    };

    render() {
        //console.log(this.props.location);
        return (
            <React.Fragment>
                <nav className={`${this.props.className} ${this.state.folded || this.props.folded ? 'folded' : ''}`}>
                    <div className={'container'}>
                        <NavWrapper>
                            <Logo>
                                <Link to={'/'}><img src={logo} alt={'logo'}/></Link>
                            </Logo>
                            <NavActions>
                                <Button to={'/catalog'} wireframe menu fixedMin
                                        label={<Translation k={'VIEW_CATALOG'}/>}/>
                                <CartButton to={'/cart'}>
                                    <i className="icon-cart"/>
                                    {this.props.cartCount ? <CartCount>{this.props.cartCount}</CartCount> : ''}
                                </CartButton>
                            </NavActions>
                        </NavWrapper>
                    </div>
                </nav>
                {this.props.folded ? <Placeholder/> : ''}
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        cartCount: state.getIn(['cart', 'items']).size,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(styled(Nav)`
  z-index: ${p => p.theme.zMenu};
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 80px;
  ${mixins.ease()}
  &:before{
    ${mixins.pseudoToBlock()}
    ${mixins.stretch()}
    ${mixins.ease()}
    bottom: -40px;
    background: rgb(0,0,0);
    background: linear-gradient(180deg, rgba(27,33, 39 ,0.5) 30%, rgba(27,33, 39 ,0) 100%);
  }
  &.folded{
    height: 60px;
    background-color: ${p => p.theme.cAccentActive};
    box-shadow: 0 0 30px 0 rgba(0,0,0,0.4);
    &:before{
      opacity: 0;
    }
  }
`));
